// import {} from './hr.js';
import {} from './lijnen.js';

// Path: themes/intercel-thema/assets/scripts/main.js
import { upArrow } from './animations.js';
import { mobileNavigation } from './mobileNavigation.js';
const navigationHeight = document.querySelector('header.wp-block-template-part .header').offsetHeight;
document.documentElement.style.setProperty('--scroll-padding', navigationHeight - 1 + 'px');

mobileNavigation();
upArrow();
